export const MIGRATION_STATUS_COLUMNS = [
  "code",
  "status",
  "isEmpty",
  "isMb1",
  "successfulTs",
];
